import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import styles from './jocCard.module.scss';

const JocCard = (props) => {
    const { imatgeSrc, titol, descripcio, alt, linkTipus, slug, textBoto, href, novaFinestra } = props;

    // Contingut comú extret
    const cardContent = (
        <div className={styles.contentCard}>
            <div className={styles.contentImatge}>
                <Imatge src={imatgeSrc} layout='fill' objectFit='cover' alt={alt} />
            </div>
            <p className={styles.titol}>{titol}</p>
            {descripcio && <p className={styles.descripcio}>{descripcio}</p>}
            <div className={styles.boto}>
                {textBoto && <p>{textBoto}</p>}
                {!textBoto && <p>Juga ara</p>}
            </div>
        </div>
    );

    // Props condicionals per l'Enllac
    const enllacProps = href 
        ? { href, novaFinestra }
        : { type: linkTipus, slug, novaFinestra };

    return (
        <Enllac className={styles.enllacCard} {...enllacProps}>
            {cardContent}
        </Enllac>
    );
};

export default JocCard;
